export default __webpack_public_path__ + "static/media/add_to_playlist.bd41c147.svg";